import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "flex items-baseline gap-2" }
const _hoisted_3 = { class: "text-sm font-bold text-neutral50" }
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-gray-400"
}
const _hoisted_5 = { class: "mt-3 grid grid-cols-1 gap-x-4 gap-y-1 md:grid-cols-12" }


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitFormSection',
  props: {
    title: {},
    hint: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.hint)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.hint), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})